<form>
  <app-text-input [control]="getControl('name')" [label]="'Test-Name' | translate" [placeholder]="'Name des Tests eingeben'"></app-text-input>
  <div class="buttons-container">
    <app-button [text]="'Test erstellen'" type="button" (click)="saveTest()" [loading]="isLoading"></app-button>
  </div>
</form>